module.exports = __webpack_public_path__ + "static/img/java-bg.a8eeb061.png";